// tdj2.js and various components call `Vue.notify(...)` directly (a static
// call on the Vue constructor) rather than `this.$notify(...)`. Vue 3's
// `vue` package has no default-exported constructor to hang a static method
// off of anymore, so that pattern needs an actual importable function -
// this is it. The Vue plugin in ./vue-notification/index.js also exposes
// this same function as `app.config.globalProperties.$notify` for template/
// `this.$notify(...)` use, so both call styles share one implementation.
import { events } from './vue-notification/events'

export const notify = (params) => {
    if (typeof params === 'string') {
        params = { title: '', text: params }
    }

    if (typeof params === 'object') {
        events.emit('add', params)
    }
}
